import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleResponse } from 'src/functions/http-handler';
import { PrintService } from './print.service';
import { FileSaverService } from 'ngx-filesaver';
import { environment } from 'src/environments/environment';
import { IPagedList } from 'src/models/paged-list.model';

const PRINT_TITLE = '협력사 거래 품목';

@Injectable({
  providedIn: 'root'
})
export class TradeItemService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private fileSaver: FileSaverService,
    private printSvc: PrintService,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/TradeItem`;
  }

  get(param: any) {
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<IPagedList<ITradeItem>>(this.logger, 'retrieve trade-item'));
  }

  print(param: any) {
    let title = document.createElement('h2');
    title.innerText = PRINT_TITLE;
    return this.printSvc.print(this.http, `${this._apiUrl}/Print`, param, title);
  }

  export(param: any, type: 'sheet' | 'pdf') {
    const mimeType = (type == 'sheet') ? environment.mimeTypes.excel : environment.mimeTypes.pdf;
    const extension = (type == 'sheet') ? '.xlsx' : '.pdf';

    return this.http.get(`${this._apiUrl}/Export`, {
      headers: { 'Accept': mimeType },
      responseType: 'blob', // This must be a Blob type
      params: param
    }).subscribe((res: Blob) => {
      var filename = `TradeItem${extension}`;
      this.saveAsBlob(res, filename, mimeType);
    })
  }

  private saveAsBlob(data: any, filename: string, mimeType: string) {
    const file = new File([data], filename, { type: mimeType });
    this.fileSaver.save(file, filename);
  }
}

export interface ITradeItem {
  vendorCode: string,
  vendorName: string,
  itemID: string,
  itemName: string,
  purchPrice: number,
  currency: string,
  visibleyn: string,
}
